var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dialog",class:_vm.modalData?.wrapperClass},[_c('div',{staticClass:"iframe-container"},[_c(_setup.LIframe,{attrs:{"src":_vm.modalData.url,"allow":"autofocus; storage-access","crossorigin":"anonymous","data-crm-modal":"true"},on:{"load":_setup.handleIframeLoad}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }